import { ref } from 'vue';

// Shared across all instances. Only ever written from client-side events, never during SSR.
const announcement = ref('');
let pendingRestore = null;

// Long enough for assistive tech to register the empty state before the message returns.
const RESTORE_DELAY_MS = 100;

/**
 * Feeds the single `EventsLiveRegion` that is mounted with the Events page.
 * Clearing before setting makes a repeated message announce again. The restore runs in a later
 * task, and a newer announcement cancels a pending one.
 */
export function useEventsAnnouncer() {
  function announce(message) {
    if (!message) return;
    clearTimeout(pendingRestore);
    announcement.value = '';
    pendingRestore = setTimeout(() => {
      announcement.value = message;
      pendingRestore = null;
    }, RESTORE_DELAY_MS);
  }

  return { announcement, announce };
}
